import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import {getPowerSystemCookie} from '@/utils/auth'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_LOGIN_API,
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // const urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
    // config.headers.Authorization = `Bearer ${urlInfo.token}`
    // config.headers.systemCode = urlInfo.systemCode
    // config.headers.hostIp = urlInfo.ip
    const urlInfo = getPowerSystemCookie() ? JSON.parse(getPowerSystemCookie()) : {}
    config.headers.Authorization = `Bearer ${urlInfo.token || ''}`
    config.headers.systemCode = process.env.VUE_APP_SYSTEM_CODE
    // config.headers.hostIp = urlInfo.ip
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 'success') {
      return res
    }
    if (res.choices && res.choices.length > 0) {
      return res
    }
    if (res.code !== '000000') {
      if (res.code === '000008') {
        const urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
        MessageBox.prompt('您的登陆已过期请重新输入密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          inputType: 'password',
          inputPattern: /\S/,
          inputErrorMessage: '密码不能为空',
          showClose: false,
          closeOnClickModal: false,
          closeOnHashChange: false
        }).then(({ value }) => {
          const loginForm = {
            username: urlInfo.username,
            password: value,
            systemCode: urlInfo.systemCode
          }
          store.dispatch('Login', loginForm)
        }).catch((err) => {
          console.log(err)

          // window.close()
        })
      }
      if (res.code === '000005' || res.code === '000008') {
        // MessageBox.confirm(
        //   '你已被登出，可以取消继续留在该页面，或者重新登录',
        //   '确定登出',
        //   {
        //     confirmButtonText: '重新登录',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }
        // ).then(() => {
        //   store.dispatch('FedLogOut').then(() => {
        //     window.close()
        //   })
        // })
        window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error('error'))
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
